export default {
  toolbar: [
    { name: 'document', items: [ 'Source', '-', 'Templates' ] },
    { name: 'tools', items: [ 'Maximize', 'ShowBlocks' ] },
    { name: 'clipboard', items: [ 'Cut', 'Copy', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ] },
    { name: 'editing', items: [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ] },
    { name: 'forms', items: [ 'Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField' ] },
    '/',
    { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ] },
    { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
    { name: 'links', items: [ 'Link', 'Unlink', 'Anchor' ] },
    { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Iframe' ] },
    '/',
    { name: 'styles', items: [ 'Styles', 'Format', 'Font', 'FontSize', 'LineHeight' ] },
    { name: 'colors', items: [ 'TextColor', 'BGColor' ] }
  ],
  extraPlugins: '',
  allowedContent: true,
  extraAllowedContent: {
    'div article header aside span p a em strong h1 h2 i': {
      attributes: ['itemscope', 'itemtype', 'itemprop']
    },
    'time': {
      attributes: ['itemprop', 'datetime']
    }
  },
  format_tags: 'p;h1;h2;h3;pre',
  removeDialogTabs: 'image:advanced;link:advanced',
  templates_files: ['/static/js/cktemplates.js']
}



// WEBPACK FOOTER //
// ./src/modules/helpers/ckeditorconfig.js